export default __webpack_public_path__ + "static/media/jobbik.bf9ae0a4.png";